import BaseEnumType from "../../common/base-enum-type";

const CourtType = Object.freeze({
    Grass: { ...new BaseEnumType("1", "Grass"), value: 1 },
    Clay: { ...new BaseEnumType("2", "Clay"), value: 2 },
    Hard: { ...new BaseEnumType("3", "Hard"), value: 3 },
    Indoor: { ...new BaseEnumType("4", "Indoor"), value: 4 }
});

export default CourtType;
